export const productivity_time = [
  { char: '⏳', name: 'Hourglass', nameZh: '倒數計時', keywords: ['wait', 'deadline', 'time', '趕稿'], hot: true },
  { char: '⌛', name: 'Hourglass Done', nameZh: '時間到', keywords: ['stop', 'finish', 'end'] },
  { char: '⏰', name: 'Alarm Clock', nameZh: '早起/提醒', keywords: ['morning', 'alert', 'wake'] },
  { char: '⏱️', name: 'Stopwatch', nameZh: '精準管理', keywords: ['fast', 'record', 'time'] },
  { char: '⏲️', name: 'Timer', nameZh: '專注番茄鐘', keywords: ['focus', 'pomodoro', 'work'], hot: true },
  { char: '📅', name: 'Calendar', nameZh: '行事曆/規劃', keywords: ['plan', 'schedule', 'date'], hot: true },
  { char: '🗓️', name: 'Spiral Calendar', nameZh: '年度計畫', keywords: ['year', 'goal', 'plan'] },
  { char: '📈', name: 'Chart Up', nameZh: '效能提升', keywords: ['growth', 'better', 'improve'] },
  { char: '🎯', name: 'Target', nameZh: '達成目標', keywords: ['goal', 'hit', 'success'], hot: true },
  { char: '✅', name: 'Check', nameZh: '清單完成', keywords: ['done', 'todo', 'ok'], hot: true },
  { char: '📝', name: 'Memo', nameZh: '靈感紀錄', keywords: ['write', 'note', 'idea'] },
  { char: '🚀', name: 'Rocket', nameZh: '高效起飛', keywords: ['fast', 'launch', 'startup'] },
];